import React, {
  useCallback,
  useMemo,
  useRef,
  useEffect,
  useState,
} from "react";
import { connect, useSelector } from "react-redux";
import AreaChart from "./AreaChart";
import BarPlot from "./BarPlot";
import { Text } from "../../styles/Global";
import { usePlayerRankMutation } from "../../services/playerApi";
import SkeletonLoader from "../../components/SkeletonLoader";

const GameHistoryChart = ({ data, FormatTimestamps }) => {
  //   console.log("gamehistorychart data: ", data);
  return data ? (
    <div style={{ paddingTop: 25 }}>
      {data && data.length ? (
        <BarPlot
          y="key_as_string"
          x="doc_count"
          seriesField="category"
          autoHeight={true}
          data={data}
        />
      ) : (
        // <AreaChart
        //   x="key_as_string"
        //   y="doc_count"
        //   seriesField="category"
        //   autoHeight={true}
        //   data={data}
        // />
        <div
          style={{
            textAlign: "center",
            alignSelf: "center",
            marginTop: 25,
          }}
        >
          <Text>No Game History to display</Text>
        </div>
      )}
    </div>
  ) : (
    <SkeletonLoader h1={200} />
  );
};

export default GameHistoryChart;
